import React from "react";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import PropTypes from "prop-types";

const StyleSwitch = styled(Switch)(({ theme, checked }) => ({
  padding: 8,
  width: 100,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    "&::before, &::after": {
      content: checked ? '"Unblock"' : '"Block"',
      position: "absolute",
      top: 15.5,
      transform: "translateY(-50%)",
      width: 50,
      height: 16,
      left: checked ? 16 : 38,
      color: checked ? "#FFFFFF" : "#fff9",
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
    color: checked ? "red" : "#FFFF",
    position: checked ? "absolute" : "default",
    left: checked ? 0 : 12,
    top: checked ? 0 : 0,
  },
  "& input": {
    position: checked ? "absolute" : "default",
    left: checked ? 0 : 12,
    top: checked ? 0 : 0,
  },
  "& .MuiTouchRipple-root": {
    position: checked ? "absolute" : "default",
    left: checked ? 0 : 12,
    top: checked ? 0 : 0,
  },
  "& .MuiSwitch-switchBase": {
    top: checked ? 9 : 0,
    left: checked ? 50: 0,
  },
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#0832DE",
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "red",
  },
}));

export default function CustomSwitch({ label, checked, onChange }) {
  return <StyleSwitch {...label} checked={checked} onChange={onChange} />;
}

CustomSwitch.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string,
};
